import { useId, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faChevronDown, faSpinnerThird } from "@fortawesome/pro-solid-svg-icons";
import "./RunSteps.scss";

type Props = {
  steps: string[];
  "data-test-id"?: string;
};

// What Assistimo is doing while it works on a reply, collapsed to a single line unless opened
const RunSteps = ({ steps, "data-test-id": testId }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const stepListID = useId();
  const hasSteps = steps.length > 0;

  return (
    <div className="assistimo-run-steps">
      <button
        data-test-id={testId}
        type="button"
        className="assistimo-run-steps__toggle"
        aria-expanded={isExpanded}
        aria-controls={stepListID}
        disabled={!hasSteps}
        onClick={() => setIsExpanded((expanded) => !expanded)}
      >
        <FontAwesomeIcon icon={faSpinnerThird} spin fixedWidth className="assistimo-run-steps__spinner" />
        Thinking
        {hasSteps && (
          <FontAwesomeIcon
            icon={faChevronDown}
            className={`assistimo-run-steps__chevron ${isExpanded ? "assistimo-run-steps__chevron--expanded" : ""}`}
          />
        )}
      </button>
      <ul id={stepListID} className="assistimo-run-steps__list" hidden={!isExpanded} aria-live="polite">
        {steps.map((step, index) => {
          const isCurrent = index === steps.length - 1;

          return (
            <li key={index} className={`assistimo-run-step ${isCurrent ? "assistimo-run-step--current" : ""}`}>
              <FontAwesomeIcon
                icon={isCurrent ? faSpinnerThird : faCheck}
                spin={isCurrent}
                fixedWidth
                className="assistimo-run-step__icon"
              />
              {step}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default RunSteps;
